
import React, { useEffect, useState } from 'react';
import Loadar from '../../common/loader/Loader';
import { Table, Pagination, Button, Space, Dropdown, Menu, message , Modal, Input } from 'antd';
import moment from 'moment/moment';
import { Link, useParams } from 'react-router-dom';
import { Card } from 'react-bootstrap';
import { DownloadOutlined, EditOutlined, EllipsisOutlined ,RollbackOutlined } from '@ant-design/icons';
import { reailerDistIdAgainstFillers } from '../../api/login/Login';

const ResellerDownLineUserList = () => {
    const  { id }= useParams()
    const [pageNumber , setPagenumber] = useState(1)
    const [data , setData ] = useState()
    const [resetKey , setResetkey] = useState(false)
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        name: '',
        mobile: '',
        email: '',
        refer_id: '',
        kycStatus: '',
    });

    const handleChange = (e) => {
        const { id, value } = e.target;
        setFormData((prev) => ({ ...prev, [id]: value }));
    };

    const handlePhoneChange = (e) => {
        const { value } = e.target;
        // Allow up to 10 characters only (no validation, just max length)
        if (value.length <= 10) {
            setFormData((prev) => ({ ...prev, mobile: value }));
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // console.log('Submitting filter:', formData);
        setResetkey((pre)=>!pre)
        setPagenumber(1)
       
    };

    const resetForm = () => {
        setFormData({
            name: '',
            mobile: '',
            email: '',
            refer_id: '',
            kycStatus: '',
        });
        setResetkey((pre)=>!pre)
        setPagenumber(1)
    
    };

    useEffect(()=>{
        getUser()
    },[pageNumber , resetKey])
  

    const getUser = async()=>{
        setLoading(true)
        const body = {
            ...formData,
            id: id,
            page:pageNumber,
            count:10
        }
        try {
            let res = await reailerDistIdAgainstFillers(body)
            console.log(res  , "res")
            if(res?.error === false)
            {
                setData(res?.data)
            } 
        } catch (error) {
            
        } finally {
            setLoading(false)
        }
    
    }

    const onChangeVal = (e) => {
       
        setPagenumber(e)
    };

  const actionMenu = (record) => (
  <Menu>
    <Menu.Item key="1">
      <Link to={`/admin/certificate`}>BC Authorization Letter</Link>
    </Menu.Item>
    <Menu.Item key="2">
      <Link to="#">ID Card</Link>
    </Menu.Item>
    <Menu.Item key="3">
      <Link to="#">Certificate</Link>
    </Menu.Item>
    <Menu.Item key="4" onClick={() => {}}>
      Fund Transfer / Return
    </Menu.Item>
    <Menu.Item key="5" onClick={() => {}}>
      Scheme
    </Menu.Item>
    <Menu.Item key="6" onClick={() => {}}>
      Add Id Stock
    </Menu.Item>
    <Menu.Item key="7" onClick={() => {}}>
      Permission
    </Menu.Item>
    <Menu.Item key="8" onClick={() => {}}>
      Locked Amount
    </Menu.Item>
    <Menu.Item key="9">
      <Link to="/admin/member/profile/view/3">View Profile</Link>
    </Menu.Item>
  </Menu>
);

const reportMenu = (record) => (
  <Menu>
    <Menu.Item key="1">
      <Link to={`/admin/statement/apes/report/${record._id}`}>AEPS</Link>
    </Menu.Item>
    <Menu.Item key="2">
      <Link to={`/admin/statement/billpayment/report/${record._id}`}>Billpayment</Link>
    </Menu.Item>
    <Menu.Item key="3">
      <Link to={`/admin/statement/recharge/report/${record._id}`}>Recharge</Link>
    </Menu.Item>
    <Menu.Item key="4">
      <Link to={`/admin/statement/moneyTransfer/report/${record._id}`}>Money Transfer</Link>
    </Menu.Item>
    <Menu.Item key="5">
      <Link to="/admin/report/pancard/3">UtiPancard</Link>
    </Menu.Item>
    <Menu.Item key="6">
      <Link to="/admin/statement/report/2">Account Statement</Link>
    </Menu.Item>
    {/* <Menu.Item key="7">
      <Link to="/admin/statementwallet/report/2">Aeps Statement</Link>
    </Menu.Item> */}
    <Menu.Item key="9">
      <Link to={`/admin/aepswallets/report/${record._id}`}>AEPS Wallets Reports</Link>
    </Menu.Item>
    <Menu.Item key="8">
      <Link to={`/admin/wallets/report/${record._id}`}>Main Wallets Reports</Link>
    </Menu.Item>
  </Menu>
);
  

  const columns = [
  {
    title: 'Serial No.',
    key: 'serial',
    render: (text, record, index) => {
      const serialNo = index + 1;
      return <span>{serialNo}</span>;
    },
  },
  {
    title: 'Name & Type',
    key: 'name',
    render: (text, record) => (
      <div>
        <div className="fw-bold">{record.name || '-'}</div>
        <small className="text-muted">{record.member_type || '-'}</small>
      </div>
    ),
  },
  {
    title: 'Reference Code',
    dataIndex: 'refer_id',
    key: 'refer_id',
    render: (text) => text || '-',
  },
  {
    title: 'Contact Info',
    key: 'contact',
    render: (text, record) => (
      <div>
        <div>{record.mobile || '-'}</div>
        <small className="text-muted">{record.email || '-'}</small>
      </div>
    ),
  },
  {
    title: 'Main Balance',
    dataIndex: 'main_wallet',
    key: 'main_wallet',
    render: (text) => <span>₹{text || '0'}</span>,
  },
  {
    title: 'Joining Date/Time',
    key: 'createdAt',
    render: (text, record) => (
      <div>
        <div>{record.createdAt ? moment(record.createdAt).format('DD/MM/YYYY') : '-'}</div>
        <small className="text-muted">
          {record.createdAt ? moment(record.createdAt).format('HH:mm:ss') : '-'}
        </small>
      </div>
    ),
  },
 
  {
    title: 'User Current Status ',
    key: 'status',
    render: (_, record) => (
      <button
        style={{ minWidth: '100px' }}
        onClick={() => {}}
        className={record?.status ? `btn btn-success` : `btn btn-danger`}
      >
        {record?.status ? 'Active' : 'Deactive'}
      </button>
    ),
  },
  {
    title: 'Status',
    key: 'is_approved',
    render: (text, record) => (
      <select
        className={`form-select form-select-sm ${record.is_approved ? 'border-success' : 'border-danger'}`}
        style={{ width: '120px' }}
        value={record.is_approved?.toString() || "false"}
        onChange={() => {}}
      >
        <option value="true">Approved</option>
        <option value="false">Not Approved</option>
      </select>
    ),
  },
  {
    title: 'Action',
    key: 'action',
    render: (text, record) => (
      <Space size="small" className="d-flex">
        <Dropdown overlay={actionMenu(record)} trigger={['click']}>
          <Button size="small" className="btn-action">
            Action <EllipsisOutlined />
          </Button>
        </Dropdown>
        <Dropdown overlay={reportMenu(record)} trigger={['click']}>
          <Button size="small" className="btn-report">
            Reports <EllipsisOutlined />
          </Button>
        </Dropdown>
        <Link to={`/admin/create-user/${record._id}`} className="btn btn-primary btn-sm">
          <EditOutlined />
        </Link>
      </Space>
    ),
  },
  {
    title: 'Reverse Payment',
    key: 'reversePayment',
    render: (text, record) => (
      <Button
        type="primary"
        danger
        icon={<RollbackOutlined />}
        onClick={() => {}}
      >
        Reverse
      </Button>
    ),
  },

];

  return (
    <>
    {loading && <Loadar/>}
     <div className="row m-4">
            <div className="col-xl-12" style={{ padding: 0 }}>
                <div className="card">
                    <div className="card-body p-0">
                        <div className="table-responsive active-projects style-1">
                            <div className="tbl-caption tbl-caption-2">
                                <h4 className="heading mb-0">
                                    <b>Filter Reseller Downline User</b>
                                </h4>
                            </div>

                            <form
                               
                                className="row cusforms"
                                style={{ padding: 20 }}
                                onSubmit={handleSubmit}
                            >
                                <div className="form-group col-4">
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="name"
                                        placeholder="Enter name"
                                        value={formData.name}
                                        onChange={handleChange}
                                    />
                                </div>

                                <div className="form-group col-4">
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="mobile"
                                        placeholder="Enter 10-digit mobile number"
                                        value={formData.mobile}
                                        onChange={handlePhoneChange}
                                    />
                                </div>

                                <div className="form-group col-4">
                                    <input
                                        type="email"
                                        className="form-control"
                                        id="email"
                                        placeholder="Enter email"
                                        value={formData.email}
                                        onChange={handleChange}
                                    />
                                </div>

                                <div className="form-group col-4">
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="refer_id"
                                        placeholder={`Enter ref id`}
                                        value={formData.refer_id}
                                        onChange={handleChange}
                                    />
                                </div> 

                                 <div className="form-group col-4">
                                    <select
                                        className="form-control"
                                        id="kycStatus"
                                        value={formData.kycStatus}
                                        onChange={handleChange}
                                    >
                                        <option value="">Select KYC Status</option>
                                        <option value="verified">Verified</option>
                                        <option value="unverified">Unverified</option>
                                    </select>
                                </div> 

                            

                                <div className="form-group col-12" style={{ margin: "20px 0" }}>
                                    <button type="submit" className="btn btn-primary">
                                        SEARCH
                                    </button>
                                    <button type="button" className="btn btn-secondary" onClick={resetForm}>
                                        RESET
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div className="m-4">
      <Card>
        <Card.Header className=" active-projects style-1">
          
          <div className="w-100 tbl-caption">
                  <h4 className="heading mb-0"><b>{'Reseller Downline User'} List</b></h4>
                  <div>
                   
                    {/* <CSVLink 
                data={csvData} 
                filename={`${params?.name || 'distributor'}_list.csv`}
                className="btn btn-primary border border-white"
                style={{backgroundColor:'bs(--nav)'}}
              >
                <DownloadOutlined /> Download Excel
              </CSVLink> */}
                    
                  </div>
                </div>
        </Card.Header>
        <Card.Body className="p-0">
         
          <Table
            columns={columns}
            dataSource={data?.user || []}
            rowKey={(record) => record?._id || Math.random()}
            loading={loading}
            pagination={false}
            className="custom-table"
            scroll={{ x: true }}
          />
          <div className="p-3 d-flex justify-content-between align-items-center">
            <div>
              Total {data?.totalCount || 0} entries
            </div>
            <Pagination
              total={data?.totalCount || 0}
              onChange={onChangeVal}
              showSizeChanger={false}
              current={pageNumber}
              showQuickJumper
              
            />
          </div>
        </Card.Body>
      </Card>

    
 

 
    </div>   
    
    </>
  )
}

export default ResellerDownLineUserList

